import { useMediaQuery } from 'react-responsive';
import { useSelector, useDispatch } from 'react-redux';
// Import your action creators
import { saveAmendmentData, setStep } from '../../redux/actions';

import React, { useRef, useState, useEffect } from "react";
import AnvilSignatureModal from '@anvilco/react-signature-modal'
import '@anvilco/react-signature-modal/dist/styles.css'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext/AuthContext.jsx';
import config from '../../utils/config.js'


const AmendExtendPacketSign = ({formId, selectedIndex, step}) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const amendmentData = useSelector((state) => {
    const amendments = state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.amendments;
    return amendments?.[amendments.length - 1].amendmentData;
  });

  const formData = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]); 
  // console.log("Buyer 1 Email", buyer1Email, "Buyer 2 Email", buyer2Email);

  // State hooks for form fields (assuming they are part of amendmentData)
  const [lastContractDate, setLastContractDate] = useState(amendmentData && amendmentData.contractCompletionDate);
  const [buyer1FirstName, setBuyer1FirstName] = useState(amendmentData && amendmentData.buyer1FirstName);
  const [buyer1LastName, setBuyer1LastName] = useState(amendmentData && amendmentData.buyer1LastName);
  const [buyer1Email, setBuyer1Email] = useState(amendmentData && formData?.buyer1Email);
  const [buyer2FirstName, setBuyer2FirstName] = useState(amendmentData && amendmentData.buyer2FirstName);
  const [buyer2LastName, setBuyer2LastName] = useState(amendmentData && amendmentData.buyer2LastName);
  const [buyer2Email, setBuyer2Email] = useState(amendmentData && formData?.data?.tenants?.[0]?.tenantEmail);
  const [seller1Name, setSeller1Name] = useState(amendmentData && amendmentData.seller1Name); 
  const [seller2Name, setSeller2Name] = useState(amendmentData && amendmentData.seller2Name); 
  const [listingAgentName, setListingAgentName] = useState(amendmentData && amendmentData.listingAgentName); 
  const [listingAgentEmail, setListingAgentEmail] = useState(amendmentData && amendmentData.listingAgentEmail); 
  const [amendmentId, setAmendmentId] = useState(amendmentData && amendmentData.amendmentId);
  const [contractCompletionDate, setContractCompletionDate] = useState(amendmentData && amendmentData.contractCompletionDate);
//   const [amendmentDate, setAmendmentDate] = useState(amendmentData && amendmentData.amendmentDate);
  const [amendmentDate, setAmendmentDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(amendmentData && amendmentData.expirationDate);  
  const [currentDates, setCurrentDates] = useState(amendmentData && amendmentData.currentDates || {});
  const [newDates, setNewDates] = useState(amendmentData && amendmentData.newDates || {});
  const [otherDatesText, setOtherDatesText] = useState(amendmentData && amendmentData.otherDatesText);
  const [otherAmendmentsText, setOtherAmendmentsText] = useState(amendmentData && amendmentData.otherAmendmentsText);
  const [sendToSeller, setSendToSeller] = useState(amendmentData && amendmentData.sendToSeller);
  const [packetDetails, setPacketDetails] = useState({});
  const [propertyDescription, setPropertyDescription] = useState(
    amendmentData?.propertyDescription || 
    formData?.propertyData?.data?.lotInfo?.legalDescription || 
    formData?.data?.propertyDescription
  );
  const [address, setAddress] = useState(amendmentData && amendmentData.address);
  const [county, setCounty] = useState(
    amendmentData?.county ||
    formData?.propertyData?.data?.ownerInfo?.mailAddress?.county ||
    formData?.data?.propertyCounty
  );
  const [selectedContract, setSelectedContract] = useState(selectedIndex);


    const [signingURL, setSigningURL] = useState('');
    const [packetEid, setPacketEid] = useState(null); 
    const [documentGroupEid, setDocumentGroupEid] = useState(null);
    // const [packetDetails, setPacketDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [eventObject, setEventObject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    // const [amendmentId, setAmendmentId] = useState(null);
    // const [dates, setDates] = useState({
    //     // For each key, have separate fields for noChange and delete
    //     key1: { date: '...', noChangeChecked: true, deleteChecked: false },
    //     // ... other keys
    // });
    // const [newDates, setNewDates] = useState({}); 
    // const [currentDates, setCurrentDates] = useState({});
    const { token } = useAuth();
    const navigate = useNavigate();

    const handleSave = () => {
      const amendmentDateString = amendmentDate.toISOString();
      // Construct the amendmentData object from local state
      const updatedAmendmentData = {
        buyer1FirstName: buyer1FirstName,
        buyer1LastName: buyer1LastName,
        buyer2FirstName: buyer2FirstName,
        buyer2LastName: buyer2LastName,
        seller1Name: seller1Name, 
        seller2Name: seller2Name, 
        listingAgentName: listingAgentName,
        listingAgentEmail: listingAgentEmail,
        contractCompletionDate: contractCompletionDate,
        amendmentDate: amendmentDateString, 
        amendmentId: amendmentId,
        expirationDate: expirationDate,
        currentDates: currentDates,
        newDates: newDates,
        otherDatesText,
        otherAmendmentsText,
        sendToSeller: sendToSeller,
        packetDetails,
        propertyDescription: propertyDescription,
        address: address,
        county: county,
        selectedContract: selectedContract
  
        // Include other fields as necessary
      };
      dispatch(saveAmendmentData(formId, updatedAmendmentData));
    };

    useEffect(() => {
      if (amendmentData && Object.keys(amendmentData).length > 0) {
          // console.log("Create Packet called: ", amendmentData);
          const body = {amendmentData, amendmentId, formId};
          // fetch('http://localhost:5000/api/amendment/packet/create', {
            fetch(`${config.apiBaseUrl}/amendment/packet/create`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
          })
          .then(response => response.json())
          .then(data => {
            // console.log('Data:', data);
            setPacketEid(data?.data?.data?.createEtchPacket?.eid); 
            setPacketDetails(data?.data?.data?.createEtchPacket);
          })
          .catch((error) => {
              console.error('There was an error!', error);
          });
      }
  }, []);

  useEffect(() => {
    // Check if packetEid is available before making the request
    if (packetEid && !isModalOpen) {
      // Extract the first signer from the documentGroup
      const signer = packetDetails?.documentGroup?.signers[0];
  
        fetch(`${config.apiBaseUrl}/amendment/packet/sign`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: signer?.eid, // Use signer.eid as userId
          signerEid: signer?.eid,
          clientId: signer?.aliasId,
          etchPacketEid: packetEid,
          documentGroupEid: packetDetails?.documentGroup?.eid,
        }),
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Data from /packet/sign:', data);
        if (data.statusCode === 200) {
          setSigningURL(data.url);
          // console.log("Signing URL:", data.url);
          setIsLoading(false);
          setIsModalOpen(true);
          // console.log('isModalOpen:', isModalOpen);
        } else {
          console.error('Error generating sign URL:', data.error);
        }
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });
    }
  }, [packetEid, isModalOpen]); // Depend on packetEid so the effect runs whenever packetEid changes

// Close the modal when signerComplete event is received
  useEffect(() => {
    if (eventObject?.action === 'signerComplete') {
      setIsModalOpen(false);
      handleSave();
      navigate(`/amendment/packet/finish?etchPacketEid=${eventObject.etchPacketEid}&documentGroupEid=${documentGroupEid}&formId=${formId}&si=${selectedContract}`);
    }
  }, [eventObject]);

  // console.log("Packet Details:", packetDetails);
  // console.log("Amendment Data:", amendmentData);
  // console.log("Amendment ID:", amendmentId);
  // console.log("Form ID:", formId);

  const renderSignModal = () => (
      <AnvilSignatureModal
        iframeURL={signingURL}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onEvent={(event) => {
            // console.log('Event object:', event);
            setEventObject(event);
        }}
        // anvilURL = "http://localhost:5173"
      />
  );
if (isLoading) {
    return <p>Loading...</p>;
}
  return (
    <div >
    <h1>Building your Signature Document</h1>
      {renderSignModal()}
    </div>
  );
}

export default AmendExtendPacketSign; 